/**
 * 카드 부속품 — 요약 수치(Headline)와 '관측 부족' 펼침(LowCoverageNotice).
 *
 * **카드 껍데기는 여기 없다.** 예전에는 이 파일에 `WidgetShell` 이 있어서 품질
 * 페이지는 그것을, 개요 페이지는 `ChartFrame` 을 썼다. 껍데기가 두 종류이면
 *
 *   - 같은 행의 카드 높이가 어긋나고 (실측 478 vs 422px),
 *   - 플롯이 서로 다른 y 에서 시작하고,
 *   - 한쪽에만 표 뷰·눈금 설명이 없다.
 *
 * 그래서 껍데기를 `ChartFrame` 하나로 합쳤고 이 파일에는 부속품만 남겼다.
 */

import type { ReactNode } from 'react'

import './WidgetShell.css'

/** 위젯 헤더의 요약 수치 — 본문을 보기 전에 결론이 먼저 읽혀야 한다 */
export function Headline({ value, unit, tone = 'neutral' }: {
  value: string
  unit?: string
  tone?: 'neutral' | 'up' | 'down' | 'warn'
}) {
  return (
    <span className={`headline headline--${tone}`}>
      <span className="headline__value num">{value}</span>
      {unit && <span className="headline__unit">{unit}</span>}
    </span>
  )
}

/** 관측 부족 항목을 숨기지 않고 펼칠 수 있게 보여준다 (§8.7 세 번째 상태). */
export function LowCoverageNotice({ count, children }: { count: number; children?: ReactNode }) {
  if (count <= 0) return null
  return (
    <details className="lowcov">
      <summary>
        관측 커버리지가 기준 미만이라 순위에서 제외된 항목{' '}
        <span className="num">{count.toLocaleString('ko-KR')}</span>건
      </summary>
      <div className="lowcov__body">{children}</div>
    </details>
  )
}
